import { UploadIcon, LinkedInIcon } from '../icons/Icons'
import styles from './QuickActions.module.css'

interface QuickActionsProps {
  onUploadClick?: () => void
  isUploading?: boolean
}

export function QuickActions({ onUploadClick, isUploading = false }: QuickActionsProps) {
  return (
    <div className={styles.actions}>
      <button
        className={styles.action}
        onClick={onUploadClick}
        disabled={isUploading}
      >
        <div className={styles.iconWrapper}>
          <UploadIcon className={styles.icon} />
        </div>
        <span>{isUploading ? 'Uploading...' : 'Upload'}</span>
      </button>
      <button className={styles.action}>
        <div className={styles.iconWrapper}>
          <LinkedInIcon className={styles.icon} />
        </div>
        <span>LinkedIn</span>
      </button>
    </div>
  )
}
